import { services } from '@/mocks/soniem';

export default function ServicesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
            Nuestros Servicios
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
            Todo lo que necesitas para{' '}
            <span className="text-primary-500">proteger tu arte</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            Ofrecemos servicios integrales para la gestión, protección y desarrollo 
            de la carrera de nuestros artistas afiliados.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="group relative bg-background-50 border border-secondary-200/60 rounded-2xl p-6 md:p-8 transition-all duration-500 hover:-translate-y-1 hover:border-primary-200/60"
            >
              {/* Icon */}
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-50 flex items-center justify-center mb-5 transition-colors duration-500 group-hover:bg-primary-100">
                <i className={`${service.icon} text-2xl md:text-3xl text-primary-500`} />
              </div>

              {/* Content */}
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                {service.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-5">
                {service.description}
              </p>

              {/* Features list */}
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-xs md:text-sm text-foreground-600">
                    <i className="ri-check-line text-primary-500 text-base flex-shrink-0" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}